<template>
  <q-page class="flex flex-center" style="background: #ddd3">
    <q-card style="width: 300px">
      <!-- лого -->
      <div style="margin-top: -50px" class="text-center">
        <q-avatar class="shadow-2" size="100px">
          <img src="@nitra/components/assets/logo.jpeg" />
        </q-avatar>
      </div>

      <!-- вход по логину/паролю -->
      <q-card-section class="q-pb-none">
        <q-form @submit="loginSubmit" class="full-width q-gutter-y-md" autocomplete="on">
          <div v-if="loginError" class="text-white text-red bg-red-1 q-pa-xs q-mb-md text-center">{{ loginError }}</div>

          <q-input
            id="login"
            v-model.trim="login"
            type="login"
            :label="t`Логін`"
            class="q-mb-md"
            outlined
            autocomplete="username">
            <template #prepend>
              <q-icon name="person" />
            </template>
          </q-input>

          <q-input
            id="password"
            v-model="password"
            :type="isPwd ? 'password' : 'text'"
            autocomplete="current-password"
            label="Пароль"
            outlined>
            <template #prepend>
              <q-icon name="vpn_key" />
            </template>
            <template #append>
              <q-icon @click="isPwd = !isPwd" :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer" />
            </template>
          </q-input>
          <q-btn
            v-if="login && password && password.length > 4"
            :loading="loginLoading"
            type="submit"
            :label="t`Увійти`"
            class="full-width"
            padding="md"
            color="primary" />
        </q-form>

        <n-forgot-pass />
      </q-card-section>
      <!-- или -->
      <q-card-section class="row items-center q-gutter-x-md">
        <q-separator class="col" />
        <div>{{ t`АБО` }}</div>
        <q-separator class="col" />
      </q-card-section>

      <q-card-section v-if="apple || google" class="q-gutter-y-md">
        <!-- вход по email -->
        <q-input
          v-model="email"
          type="email"
          :label="t`Вхід через E-mail`"
          debounce="300"
          :rules="[checkEmail]"
          :error-message="t`Помилковий формат email`"
          :hint="email ? t`на цю адресу буде надіслано код` : undefined"
          hide-bottom-space
          outlined
          autofocus>
          <template #prepend>
            <q-icon name="mail" />
          </template>
        </q-input>
        <q-btn
          v-if="email && checkEmail(email)"
          @click="emailSubmit"
          :label="t`Отримати код`"
          :loading="emailLoading"
          class="full-width q-mt-md"
          padding="md"
          color="primary" />

        <!-- google логин -->
        <div v-if="google">
          <n-login-google :id="google" v-model="authorized" />
        </div>
        <!-- apple логин -->
        <div v-if="apple">
          <n-login-apple :id="apple" v-model="authorized" />
        </div>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script setup>
import { date } from 'quasar'
import cookieLogin from '@nitra/components/njs/cookieLogin.js'
import { checkToken } from '@nitra/components/njs/token.js'
import NForgotPass from '@nitra/components/NForgotPass'
import tf from '@nitra/tf/webpack'
import { ref, computed, watchEffect } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import NLoginApple from '@nitra/components/NLoginApple'
import NLoginGoogle from '@nitra/components/NLoginGoogle'

const router = useRouter()
const google = process.env.GOOGLE_ID
const apple = process.env.APPLE_ID

const authorized = ref(false)

// событие когда пользователь авторизован
const emit = defineEmits(['input'])

// Авторизація з кукі
cookieLogin()

// Translate
const tr = {
  'Некоректний формат email': 'Некорректный формат email',
  'на цю адресу буде надіслано код': 'на этот адрес будет отправлен код',
  'Отримати код': 'Получить код',
  АБО: 'ИЛИ',
  Логін: 'Логин',
  Увійти: 'Войти',
  'Вхід через E-mail': 'Вход через E-mail',
  'Користувачу ': 'Пользователю ',
  ' не дозволено входити в цей додаток': ' не разрешено входить в данное приложение',
  'Невірний логін або пароль': 'Неверный логин или пароль',
  'Помилка: ': 'Ошибка: '
}

const t = tf.bind({ tr })

defineProps({
  logo: {
    type: String,
    default: 'https://cdn.jsdelivr.net/npm/@nitra/auth-components@2/assets/logo.jpeg'
  }
  // google: {
  //   type: String,
  //   default:  process.env.GOOGLE_ID
  // },
  // // apple signin options
  // apple: {
  //   type: String,
  //   default: process.env.APPLE_ID
  // }
})

// ВХОД ПО EMAIL
const email = ref(localStorage.getItem('email') || '')
const emailLowerCased = computed(() => email.value.toLowerCase())
const emailLoading = ref(false)
// ВХОД ПО ЛОГИНУ/ПАРОЛЮ
const login = ref(null)
const password = ref(null)
const isPwd = ref(true)
const loginLoading = ref(false)
const loginError = ref('')

// валидный ли адрес
const checkEmail = email => {
  if (!email) {
    return true
  }

  if (email.length > 320) {
    return false
  }

  const regex =
    /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/

  return regex.test(String(email).toLowerCase().trim())
}

const loginSubmit = async () => {
  loginLoading.value = true

  const data = { login: login.value, pass: password.value }
  const headers = {
    'Content-Type': 'application/json'
  }
  if (process.env.APP) {
    headers['app'] = process.env.APP
  }
  const response = await fetch('/auth/send-login-pass', {
    method: 'POST',
    headers,
    body: JSON.stringify(data)
  })

  const res = await response.json()
  if (res.error) {
    if (Object.keys(res.error) === 0 || JSON.stringify(res.error).includes('Incorrect auth')) {
      loginError.value = t`Невірний логін або пароль`
    } else {
      loginError.value = t`Помилка: ${JSON.stringify(res.error)}`
    }
  } else {
    if (checkToken(res.token)) {
      window.location.replace('/')
    } else {
      loginError.value = t`Користувачу ${login.value} не дозволено входити в цей додаток`
    }
  }

  loginLoading.value = false
}

const emailSubmit = async () => {
  emailLoading.value = true
  loginError.value = ''

  const response = await fetch('/auth/otp-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: emailLowerCased.value,
      href: window.location.origin + '/code'
    })
  })

  const res = await response.json()

  if (res.error) {
    loginError.value = t`Помилка: ${JSON.stringify(res.error)}`
  } else {
    localStorage.setItem('email', emailLowerCased.value)
    localStorage.setItem('email-otp-date', date.addToDate(new Date(), { minutes: 30 }))
    await router.push('/code')
  }

  emailLoading.value = false
}

watchEffect(() => {
  if (authorized.value) {
    emit('input', true)
  }
})
</script>

<style lang="scss">
.body--light input:-webkit-autofill {
  -webkit-text-fill-color: $primary;
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}
.body--dark input:-webkit-autofill {
  -webkit-text-fill-color: $primary;
  -webkit-box-shadow: 0 0 0 1000px #000d inset !important;
}
</style>
